import React from "react"
import { ACCEPTABLE_USE_POLICY } from "../../constants"

export default () => (
  <div data-testid="acceptable-use-policy">
    <div className="legal-component">
      <div className="legal-aup">
        <p className="privacy-policy-content-title">{ACCEPTABLE_USE_POLICY}</p>
        <p className="privacy-policy-content-text">
          Please ensure you have read, understood and adhere to the following
          summary of the main points of the organisation’s policies with regard
          to information security.
        </p>
        <ol>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I acknowledge that my use of the Hub and communications systems may
            be monitored and/or recorded for lawful purposes.
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I accept that I am responsible for the use and protection of the
            user credentials with which I am provided (user account and
            password, access token or other items I may be provided with)
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will not use anyone else’s user account and password to access the
            Hub
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will not attempt to access any content to which I have not been
            given access to
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will protect any classified material sent, received, stored or
            processed by me according to the level of classification assigned to
            it, including both electronic and paper copies
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will always ensure that I enter the correct recipient email
            address(es) so that classified information is not compromised
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will ensure I am not overlooked by unauthorised people when
            working and will take appropriate care when printing classified
            information
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will securely store classified printed material and ensure it is
            correctly destroyed when no longer needed
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will not leave my computer unattended such that unauthorised
            access can be gained to information via my account while I am away
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will inform Kaizen immediately if I detect, suspect or witness an
            incident that may be a breach of security or if I observe any
            suspected information security weaknesses in systems or services
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will not attempt to bypass or subvert system security controls or
            to use them for any purpose other than that intended
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will take precautions to protect all computer media and mobile
            devices when carrying them outside my organisation’s premises (e.g.
            leaving a laptop unattended or on display in a car such that it
            would encourage an opportunist theft)
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will not introduce viruses or other malware into the Hub
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will not attempt to disable anti-virus protection provided at my
            computer
          </li>
          <li className="privacy-policy-content-text padding-bottom-1em">
            I will comply with the legal, statutory or contractual obligations
            that the organisation informs me are relevant to my role
          </li>
        </ol>
      </div>
    </div>
  </div>
)
